// extracted by mini-css-extract-plugin
export default {"wizardContainer":"Wizard_wizardContainer__LulqZ","techs":"Wizard_techs__UiJTo","chip":"Wizard_chip__zN8yl"};